import { render } from "./UserLoginHistory.vue?vue&type=template&id=2bce3fab"
import script from "./UserLoginHistory.vue?vue&type=script&lang=js"
export * from "./UserLoginHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__